export const SubscriptionBoxStyle = (theme) => ({
	background: {
		backgroundColor: "#F9F9F9",
		width: "100%",
		padding: "2em",
		marginTop: "2em"
	},
	background2: {
		backgroundColor: "#F9F9F9",
		width: "100%",
		padding: "2em",
		paddingLeft: "20em",
		paddingRight: "20em",
		marginTop: "2em"
	},
	backgroundHideNav: {
		backgroundColor: "#F9F9F9",
		width: "100%",
		padding: "2em"
	},
	header_area: {
		textAlign: "center"
	},
	header_text: {
		fontSize: "16px",
		letterSpacing: 2,
		margin: "1em",
		fontWeight: 500
	},
	checkbox: {
		marginTop: "1em"
	},
	text: {
		color: "#2f2f2f"
	}
})
